// extracted by mini-css-extract-plugin
export default {"basketInfos":"basketInfos__3HcGs","basketInfosTitle":"basketInfosTitle__2i5x2","basketInfosValue":"basketInfosValue__2H95q","basketInfosEdit":"basketInfosEdit__3Njsf"};
    if(module.hot) {
      // 1788784372974
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  